module.exports = __webpack_public_path__ + "static/logoWithoutMQ_2017_PNG-4be55ec7efa5689539dd90f1fe66b299.png";